<template>
  <div id="flood-hazard-index">
    <router-view></router-view>
  </div>
</template>
<script>
import { createSurvey, updateSurvey } from "@/api/survey.api";
import { mapActions, mapState } from "vuex";
export default {
  name: "FloodHazardIndex",
  props: {},
  data() {
    return {};
  },
  beforeRouteLeave(to, from, next) {
    // if (navigator.onLine) this.$_saveDataToCould();
    next();
  },
  mounted() { },
  computed: {
    ...mapState({
      floodHazardSurvey: (state) => state.Surveys.floodHazard,
      user: (state) => state.User.user,
    }),
  },
  methods: {
    ...mapActions({
      updateSurvey: "Surveys/UPDATE_FLOOD_HAZARD",
    }),
    $_saveDataToCould() {
      if (this.floodHazardSurvey) {
        if (this.floodHazardSurvey.id) {
          const payload = {
            fields: {
              survey_data: JSON.stringify(this.floodHazardSurvey),
            },
          };
          updateSurvey(this.floodHazardSurvey.id, payload)
            .then((res) => { })
            .catch((err) => {
              // Better erorr handling
              console.log(err);
              if (err.response.data) {
                console.log(err.response.data);
              }
            });
        } else {
          const payload = {
            title: `${this.user.slug}-FloodHazard`,
            author: this.user.id,
            status: "publish",
            tags: [39],
            content: `${this.user.slug}-FloodHazard`,
            fields: {
              survey_data: JSON.stringify(this.floodHazardSurvey),
            },
          };

          createSurvey(payload)
            .then((res) => {
              const surveyData = JSON.parse(res.data.acf.survey_data);
              surveyData.id = res.data.id;
              this.updateSurvey(surveyData);
            })
            .catch((err) => {
              // Better erorr handling
              console.log(err);
              if (err.response.data) {
                console.log(err.response.data);
              }
            });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
